/**
 * @desc 用户账号获取票证
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysUserTableau/tableauTrust/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
